/**
 * @public
 * enum for different types of notification events
 */
export var NotificationEvent;
(function (NotificationEvent) {
    NotificationEvent["NOTIFICATION_EVENT"] = "notification-event";
})(NotificationEvent || (NotificationEvent = {}));
